import { ReactComponent as GbIcon } from 'img/countdown/gb.svg';
import React, { ReactElement } from 'react';

export interface ICountdownPromo {
    id: string;
    text: string;
    img: ReactElement;
    onClick: () => void;
}

export const SPACE_COUNTDOWN_ID = 'gb-place';

export const COUNTDOWN_DATA = {
    id: SPACE_COUNTDOWN_ID,
    text: '<span>-20%</span> на место</br>для ваших файлов',
    img: <GbIcon width={70} height={33} />,
    productId: 'W128G1y_discount20_single_quota',
};
